import SvgIcon from "@mui/material/SvgIcon"

export default function SendItIcon() {
  return (
    <SvgIcon>
      <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
        <g fill="none" fillRule="evenodd">
          <circle cx="12" cy="12" r="12"/>
          <path
            d="M2.5 20.5V4.5l19 8-19 8zm2-3 11.85-5L4.5 7.5v3.5l6 1.5-6 1.5V17.5zm0 0V7.5v10z"
            fill="currentColor"
            fillRule="nonzero"
          />
        </g>
      </svg>
    </SvgIcon>
  )
}
